import { ModelBase } from '@singularsystems/neo-core';
import { Catalogue } from '@singularsystems/neo-react-services';
import { IGeneralApiClient } from '../../Common/ApiClients/GeneralApiClient';
import StaticDataCache from '../../Maintenance/StaticData/StaticDataCache'

/** Generic catalogue component base. */
export abstract class CatalogueEntry<TModel extends ModelBase> extends Catalogue.CatalogueEntryBase<TModel, StaticDataCache, IGeneralApiClient> {

}